<template>
  <v-container class="pa-0" @keydown.esc="closeWindow">
    <!-- nagłówek karty  -->
    <v-card class="mb-2" @keydown.esc="closeWindow" key="Header">
      <v-card-title class="py-0 px-0">
        <v-card class="m0" color="primary" dark style="width: 100%">
          <v-card-title class="pt-0 pb-2 pl-2 pr-1">
            <span class="title font-weight-bold"
              >{{ $t("ProductionTerms.Topic") }}
            </span>
            <v-spacer></v-spacer>
            <v-icon color="blue darken-1" @click="closeWindow()"
              >mdi-close
            </v-icon>
          </v-card-title>
          <v-card-subtitle class="pb-0 pb-sm-2 pl-2">
            {{ $t("ProductionTerms.TopicDescription") }}
          </v-card-subtitle>
        </v-card>
      </v-card-title>
    </v-card>
    
    
    <!-- Zawartość karty -->
    <v-card key="Profiles">
      <v-card-text class="pa-2">
        <!-- Nagłówek tabeli dla wyswietlaczy lg (dla pozostałych :brak)-->
        <v-row v-if="$vuetify.breakpoint.lgAndUp" dense class="text-body-2">
          <v-col class="col-2 pl-4 py-0" align-self="center">
            {{ $t("ProductionTerms.H_Profil") }}
          </v-col>
          <v-col class="col-10 py-0">
            <v-row dense>
              <v-col class="col-3 py-0 text-center" align-self="center">
                {{ $t("ProductionTerms.H_Color") }}
              </v-col>
              <v-col class="col-7 py-0">
                <v-row dense>
                  <v-col class="col-3 py-0 pr-0 text-right" align-self="center">
                    {{ $t("ProductionTerms.H_Type") }}
                  </v-col>
                  <v-col class="col-9 py-0">
                    <v-row dense class="py-0">
                      <v-col class="col-6 py-0"></v-col>
                      <v-col class="col-6 py-0">
                        <v-row dense class="text-center">
                          <v-col class="col-4 py-0">{{
                            $t("ProductionTerms.H_Days") | capitalize
                          }}</v-col>
                          <v-col class="col-8 py-0">{{
                            $t("ProductionTerms.H_ProdTime")
                          }}</v-col></v-row
                        >
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="col-2 text-center py-0" align-self="center">
                {{ $t("ProductionTerms.H_Delivery") }}
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <!-- Koniec nagłówka ----------- -->

        <template v-for="element in tabProfileTypes">
          <v-card :key="element.profil" outlined class="px-0 mb-1">
            <profilTerms
              :profilDatas="getProfilDatas(element)"
              :profilProducer="element.customerCode"
            ></profilTerms>
          </v-card>
        </template>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import profilTerms from "@/components/Others/ProductionTerms/PT_profilData.vue";

import axios from "axios";

export default {
  components: {
    profilTerms,
  },
  data() {
    return {
      tabProfileTypes: [],
      ProductionTerms: [],
    };
  },
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },

  methods: {
    //Sprawdza czy wskazany txt to "kolor standard"
    colorStd(txt) {
      return txt.indexOf("kolor standard") >= 0 ? true : false;
    },
    
    //API - pobieranie terminów realizacji
    async getProductsTerms() {
      window.Store.dispatch("sessionAuthorise").then((response) => {
        if (response.respond == "logged") {
          axios
            .get(window.API.ProductsTerms, window.Store.getters.getAxiosHeader)
            .then((response) => {
              this.ProductionTerms = response.data;
              this.checkProfileTypes();
            })
            .catch((errors) => {
              const errorStatus = errors.response;
              if (errorStatus == 401) {
                window.Store.dispatch("logout");
              }
            });
        } else {
          window.Store.dispatch("logout");
        }
      });
    },

    getProfilDatas(element) {
      var tab = [];
     
      this.ProductionTerms.forEach(function (row) {
        if (row.profil == element.profil && row.customerCode == element.customerCode) {
          tab.push(row);
        }
      });
      return tab;
    },

    // Sprawdzenie ilości profilów i napełnienie głównej tabeli
    checkProfileTypes() {
      var tab = [];
      this.ProductionTerms.forEach(function (row) {
        var addElement = true;
        tab.forEach(function (elem) {
          if (
            row.customerCode == elem.customerCode &&
            row.profil == elem.profil
          ) {
            addElement = false;
          }
        });
        if (addElement) {
          tab.push({ profil: row.profil, customerCode: row.customerCode });
        }
      });
      this.tabProfileTypes = tab.slice();
    },

    getProducer(profilType) {
      var i;
      var prod;
      for (i = 0; i < this.ProductionTerms.length; i++) {
        if (profilType == this.ProductionTerms[i].profil) {
          prod = this.ProductionTerms[i].customerCode;
        }
      }
      return prod;
    },
    CloseStdColor() {
      this.showDialogStdColor = false;
    },

    closeWindow() {
      this.$router.push("/");
    },
  },
  mounted() {},
  beforemount() {},
  created() {
    this.getProductsTerms();
  },
  destroyed() {},
};
</script>
